<div [formGroup]="form" id="flex-container"
  [ngClass]="isPartOfMaterialImport ? 'flex-container-row' : 'flex-container-column'">

  <div id="data-container">
    <div [ngClass]="isPartOfMaterialImport ? 'cards-container' : 'grid-container-double'">
      <mat-card class="input-card">
        <mat-card-content class="inner-container">
          <mat-form-field class="form-field-wide"
            matTooltip="{{ 'material.fields.tooltips.articleName' | transloco }}">
            <mat-label class="label-large">{{ 'material.fields.articleName' | transloco }}
            </mat-label>
            <input matInput formControlName="articleName" type="text" autocomplete="off">
            <mat-error *ngIf="form.controls.articleName.errors">
              <span *ngIf="form.controls.articleName.errors.required">
                {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
              </span>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-field-wide"
            matTooltip="{{ 'material.fields.tooltips.articleNumber' | transloco }}">
            <mat-label class="label-large">
              {{ 'material.fields.articleNumber' | transloco }}
            </mat-label>
            <input matInput formControlName="articleNumber" type="text" autocomplete="off">
            <mat-error *ngIf="form.controls.articleNumber.errors">
              <span *ngIf="form.controls.articleNumber.errors.required">
                {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
              </span>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-field-wide"
            matTooltip="{{ 'material.fields.tooltips.manufacturer' | transloco }}">
            <mat-label class="label-large">{{ 'material.fields.manufacturer' | transloco }}
            </mat-label>
            <input matInput formControlName="manufacturerName" type="text" autocomplete="off">
            <mat-error *ngIf="form.controls.manufacturerName.errors">
              <span *ngIf="form.controls.manufacturerName.errors.required">
                {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
              </span>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-field-wide"
            matTooltip="{{ 'material.fields.tooltips.manufacturingCountry' | transloco }}">
            <mat-label class="label-large">
              {{ 'material.fields.manufacturingCountry' | transloco }}
            </mat-label>
            <mat-select formControlName="manufacturingCountry">
              <mat-option [value]="null"> {{ 'common.text.noSelection' | transloco }}</mat-option>
              <mat-option *ngFor="let country of handler.manufacturingCountries" [value]="country.code">
                {{country.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.controls.manufacturingCountry.errors">
              <span *ngIf="form.controls.manufacturingCountry.errors.required">
                {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
              </span>
            </mat-error>
          </mat-form-field>
        </mat-card-content>
      </mat-card>
      <mat-card class="input-card">
        <mat-card-content class="inner-container">
          <mat-form-field class="form-field-wide"
            matTooltip="{{ 'material.fields.tooltips.gtin' | transloco }}">
            <mat-label class="label-large">{{ 'material.fields.gtin' | transloco }}</mat-label>
            <input matInput formControlName="gtin" type="text" autocomplete="off">
            <mat-error *ngIf="form.controls.gtin.errors">
              <span *ngIf="form.controls.gtin.errors.gtinError">
                {{ 'dataManagement.userData.userDialog.validation.gtinError' | transloco }}
              </span>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-field-wide"
            matTooltip="{{ 'material.fields.tooltips.totalGrammage' | transloco }}">
            <mat-label class="label-large">
              {{ 'material.fields.totalGrammage' | transloco }}
            </mat-label>
            <input matInput type="number" formControlName="totalGrammage" autocomplete="off">
          </mat-form-field>

          <mat-form-field class="form-field-wide"
            matTooltip="{{ 'material.fields.tooltips.totalWeight' | transloco }}">
            <mat-label class="label-large">
              {{ 'material.fields.totalWeight' | transloco }}
            </mat-label>
            <input matInput type="number" formControlName="totalWeight" autocomplete="off">
          </mat-form-field>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
